export default "__VITE_ASSET__C7j7g920__"